import React, { useState, useEffect } from 'react';
import PopUp from '../../components/PopUp';
import { SorterPopUpProps } from '../../types/sorter';
import { TextInput, Button, Divider, Grid, Select, Text } from '@mantine/core';
import styles from './SorterPage.module.css'
import { SorterRowType} from '../../types/sorter';
import {ReactComponent as  RemoveIcon } from '../../assets/icons/Remove.svg'
import {ReactComponent as DropdownIcon } from '../../assets/icons/Dropdown.svg'
import {useDisclosure } from '@mantine/hooks';
import { useSorterOptions } from '../../context/SorterOptionsContext';



type SorterNameFieldProps = {
    editMode: boolean;
    inputValue: string;
    setInputValue:React.Dispatch<React.SetStateAction<string>>;
    id?: number;
    error?: string;
}




const SorterNameField = ({editMode, inputValue, setInputValue, id, error}:SorterNameFieldProps) =>{
    return(
        <div className={styles.PopupInputs}>
         {editMode && (
            <TextInput
                label="Sorter Id"
                value={String(id)}
                disabled={true}
            />
        )}
        <TextInput
        label = "Sorter Name"
        value = {inputValue}
        onChange={(event) => setInputValue(event.currentTarget.value)}
        error={error}
        />
        </div>


    );


}

type FormErrors = {
    name?: string;
    center?: string;
    firmware?: string;
    colorModel?: string;
    reuseModel?: string;
    recyclingModel?: string;
    belts?: string;
}




const SorterPopUp = ({opened, close, title, edit, onSave, onDelete, sorter}: SorterPopUpProps)=>{
    const [name, setName] = useState('');
    const [center, setCenter] = useState<string|null>('')
    const [colorModel, setColorModel] = useState<string|null>('')
    const [reuseModel, setReuseModel] = useState<string|null>('')
    const [recyclingModel, setRecyclingModel] = useState<string|null>('')
    const [firmware, setFirmware] = useState<string|null>('')
    const [openedDel, handlerDel] = useDisclosure(false);
    const [popUpSorter, setPopUpSorter] = useState<SorterRowType[]>(sorter)
    const [errors, setErrors] = useState<FormErrors>({});
    const [saveError, setSaveError] = useState('');

    const {
            centerOptions,
            firmwareOptions,
            colorModelOptions,
            reuseModelOptions,
            recyclingModelOptions,
    } = useSorterOptions();



    useEffect(() => {
        // Only reset the form when the popup actually opens/closes, not on every
        // parent re-render — `sorter` is a freshly-filtered array on every render
        // of the parent list, which would otherwise wipe out in-progress edits.
        setPopUpSorter(sorter)
        setErrors({})
        setSaveError('')
        if (edit && sorter[0]?.name) {
            setName(sorter[0]?.name);
        }
        if (edit && sorter[0]?.center_id) {
            setCenter(String(sorter[0]?.center_id));
        }
        if (edit && sorter[0]?.sorter_firmware_id) {
            setFirmware(String(sorter[0]?.sorter_firmware_id));
        }
        if (edit && sorter[0]?.sorter_color_model_id) {
            setColorModel(String(sorter[0]?.sorter_color_model_id));
        }
        if (edit && sorter[0]?.sorter_reuse_model_id) {
            setReuseModel(String(sorter[0]?.sorter_reuse_model_id));
        }
        if (edit && sorter[0]?.sorter_recycling_model_id) {
            setRecyclingModel(String(sorter[0]?.sorter_recycling_model_id));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [opened]);

    const validate = (): FormErrors => {
        const newErrors: FormErrors = {};
        if (!name.trim()) {
            newErrors.name = 'Required';
        } else if (!/^[a-zA-Z0-9 ]*$/.test(name)) {
            newErrors.name = 'Only alphanumeric characters allowed.';
        }
        if (!center) newErrors.center = 'Required';
        if (!firmware) newErrors.firmware = 'Required';
        if (!colorModel) newErrors.colorModel = 'Required';
        if (!reuseModel) newErrors.reuseModel = 'Required';
        if (!recyclingModel) newErrors.recyclingModel = 'Required';

        if (popUpSorter.length === 0) {
            newErrors.belts = 'Add at least one belt.';
        } else if (popUpSorter.some(belt => {
            const hoppers = Number(belt.num_hoppers);
            return !String(belt.beltName ?? '').trim() || !Number.isInteger(hoppers) || hoppers <= 0;
        })) {
            newErrors.belts = 'Every belt needs a name and a hopper count greater than 0.';
        }

        return newErrors;
    }

    const ClickSaveButton = async () =>{
        const validationErrors = validate();
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length > 0) {
            return;
        }

        const updatedSorter = popUpSorter.map(belt => ({...belt,  name:name, center_id:Number(center), sorter_firmware_id:Number(firmware), sorter_color_model_id:Number(colorModel), sorter_recycling_model_id:Number(recyclingModel), sorter_reuse_model_id:Number(reuseModel), num_hoppers:Number(belt.num_hoppers) }))
        setPopUpSorter(updatedSorter)

        const success = await onSave(updatedSorter)
        if (success) {
            setSaveError('')
            close()
        } else {
            setSaveError('Could not save changes. Please try again.')
        }
    }


    const ClickDeleteButton = (sorterId:number) =>{
        onDelete(sorterId)
        handlerDel.close()
        close()
    }
    const handleBeltChange = (beltId:number, beltName:string)=>{
        setPopUpSorter(prevData => {
           const updated =  prevData.map((belt)=>
                belt.beltId === beltId ? {...belt, beltName: beltName} : belt
            )
            return updated;  
        })
  
    }

     const handleHoppersChange = (beltId:number, hoppers:string)=>{
        setPopUpSorter(prevData => {
            const updated =  prevData.map((belt)=>
                belt.beltId === beltId ? {...belt, num_hoppers: Number(hoppers)} : belt
            )
            return updated;  
            })
           
    }

    
    const handleAddBelt = (sorterID: number) =>{
        setPopUpSorter(prevData => {
            const maxId = prevData.reduce((max, el) => Math.max(max, el.beltId), 0); //TODO: he dejado 0
            const newBelt = {id: sorterID, name: prevData[0]?.name, center_id:1, sorter_firmware_id: 0, sorter_color_model_id: 0, sorter_reuse_model_id: 0, sorter_recycling_model_id: 0, beltId:maxId +1, beltName:"", num_hoppers:0}
            const updated =  [...prevData, newBelt]
            return updated;  
        })
        
    }

    const handleRemoveBelt = (beltId:number)=>{
        setPopUpSorter(prevData =>{
           const updated = prevData.filter(belt => belt.beltId !== beltId )
           return updated;
        }
        )
   
    }
    
    
    return(
        <div>
            <PopUp zIndex={1001} size={700} opened={openedDel} close={handlerDel.close} title="Warning" onSave={()=>ClickDeleteButton(popUpSorter[0]?.id)} button1="Delete" >Are you sure you want to delete this sorter?</PopUp>
            <PopUp opened={opened} close={close} title={title}  onSave ={()=>ClickSaveButton()}>
                <div className={styles.PopupInputs}>
                    {edit && <Button className={styles.DeleteButton} onClick={handlerDel.open} variant="filled"  radius="xl" color="#A61C3C" size="sm" > Delete Sorter </Button> }
                    <SorterNameField editMode={edit} inputValue={name} setInputValue={setName} id={popUpSorter[0]?.id} error={errors.name}></SorterNameField>
                    <Select
                        label={"Center"}
                        data={centerOptions}
                        value={center}
                        onChange={setCenter}
                        error={errors.center}
                        rightSection={<DropdownIcon width={19} height={19}></DropdownIcon>}
                    />
                    <Select
                        label={"Firmware"}
                        data={firmwareOptions}
                        value={firmware}
                        onChange={setFirmware}
                        error={errors.firmware}
                        rightSection={<DropdownIcon width={19} height={19}></DropdownIcon>}
                    />
                    <Select
                        label={"ColorModel"}
                        data={colorModelOptions}
                        value={colorModel}
                        onChange={setColorModel}
                        error={errors.colorModel}
                        rightSection={<DropdownIcon width={19} height={19}></DropdownIcon>}
                    />
                    <Select
                        label={"RecyclingModel"}
                        data={recyclingModelOptions}
                        value={recyclingModel}
                        onChange={setRecyclingModel}
                        error={errors.recyclingModel}
                        rightSection={<DropdownIcon width={19} height={19}></DropdownIcon>}
                    />

                    <Select
                        label={"ReuseModel"}
                        data={reuseModelOptions}
                        value={reuseModel}
                        onChange={setReuseModel}
                        error={errors.reuseModel}
                        rightSection={<DropdownIcon width={19} height={19}></DropdownIcon>}
                    />

                </div>

                <div className={styles.gridBelts}>
                    <span className={styles.BeltHeader}>Belt</span>
                    <span className={styles.HoppersHeader}>Hoppers</span>
                </div>
                {errors.belts && <Text c="red" size="sm">{errors.belts}</Text>}

                <Divider my="sm" size={3}  color="black"  className={styles.divider}  />
                <Grid>
                    {popUpSorter.map((sorter) => {
                    return(
                    <div key={sorter.beltId} style={{ display: 'flex' }}>
                        <Grid.Col span={5}>
                            <TextInput value={sorter.beltName} onChange ={(event) => handleBeltChange(sorter.beltId, event.currentTarget.value)} />
                        </Grid.Col>
                        <Grid.Col span={5}>
                            <TextInput value={String(sorter.num_hoppers)} onChange ={(event) => handleHoppersChange(sorter.beltId, event.currentTarget.value)}/>
                        </Grid.Col> 
                        <Grid.Col span={2}>
                            <Button variant="subtle" onClick={()=>handleRemoveBelt(sorter.beltId)}>
                                <RemoveIcon></RemoveIcon>
                            </Button>
                        </Grid.Col>        
                    </div>
                    )})}

                </Grid>
                <Button className={styles.BeltButton} onClick={()=>handleAddBelt(popUpSorter[0]?.id)} variant="subtle" color="#474973" size="sm" > + Belt </Button>
                {saveError && <Text c="red" size="sm">{saveError}</Text>}

            </PopUp>
        </div>
        
    )
}

export default SorterPopUp